import type { StoryEmote } from '@rdd/contracts'
import { emoteBar } from './emotes'
import { backToGameLink } from './screens'

/**
 * O HUD do mundo: DOM por cima do canvas (ADR 0042), para os botoes terem foco, rotulo e alvo de toque de
 * verdade. O "Voltar ao jogo" sai da sala antes de navegar -- saida consentida, que o servidor reporta com o
 * ultimo tile.
 */
export function hud(web2Url: string, onBack: () => void, onEmote: (id: StoryEmote) => void): HTMLElement {
  const layer = document.createElement('div')
  layer.className = 'hud-layer'
  const bar = document.createElement('nav')
  bar.className = 'hud'
  const back = backToGameLink(web2Url)
  back.addEventListener('click', (event) => {
    // A saida encerra a sessao no `api` antes de ir: quem chama decide quando navegar.
    event.preventDefault()
    onBack()
  })
  bar.append(back)
  layer.append(bar, emoteBar(onEmote))
  return layer
}
